import React from 'react';
import { Brain, Rocket, Users, Target } from 'lucide-react';
import Section from '../layout/Section';
import Container from '../layout/Container';

const features = [
  {
    icon: Brain,
    title: 'AI-Powered Solutions',
    description: 'Leverage cutting-edge artificial intelligence to transform your digital presence'
  },
  {
    icon: Rocket,
    title: 'Rapid Development',
    description: 'Fast, efficient development process to get your project live quickly'
  },
  {
    icon: Users,
    title: 'Expert Support',
    description: '24/7 support from our team of experienced developers and AI specialists'
  },
  {
    icon: Target,
    title: 'Results Driven',
    description: 'Focus on delivering measurable business outcomes and ROI'
  }
];

export default function Overview() {
  return (
    <Section className="bg-white dark:bg-gray-900">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl">
            Transform Your Digital Presence
          </h2>
          <p className="mt-4 text-xl text-gray-600 dark:text-gray-300">
            We combine AI technology with expert development to deliver exceptional results
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="text-center p-6 bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="inline-flex p-3 rounded-lg bg-purple-100 dark:bg-purple-900 mb-4">
                  <Icon className="w-6 h-6 text-purple-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}